import { render, staticRenderFns } from "./SingleOrderHold.vue?vue&type=template&id=31db5b1e&"
import script from "./SingleOrderHold.vue?vue&type=script&lang=js&"
export * from "./SingleOrderHold.vue?vue&type=script&lang=js&"
import style0 from "./SingleOrderHold.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports